import {useEffect,useState} from 'react';

type ClockState={status:'clocked_in'|'clocked_out';
  clockedInAt:string|null;locationCode:string|null};

/** The icon is an actual authenticated clock-in/out control on isolated PWA. */
export function StaffClock({locationCode}:{locationCode:string}){
  const [open,setOpen]=useState(false);
  const [state,setState]=useState<ClockState|null>(null);
  const [loading,setLoading]=useState(true);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  useEffect(()=>{
    const ctrl=new AbortController();
    setState(null);setLoading(true);setError('');
    void fetch('/api/v1/staff/time-clock?'+new URLSearchParams({location:locationCode}),{
      credentials:'same-origin',cache:'no-store',signal:ctrl.signal,
    }).then(async r=>{
      if(!r.ok)throw Error('Time clock unavailable.');
      const body=await r.json() as {ok:boolean;data?:ClockState};
      if(!body.ok||!body.data)throw Error('Time clock unavailable.');
      if(!ctrl.signal.aborted)setState(body.data);
    }).catch(()=>{
      if(!ctrl.signal.aborted)setError('Time clock is temporarily unavailable.');
    }).finally(()=>{if(!ctrl.signal.aborted)setLoading(false);});
    return ()=>ctrl.abort();
  },[locationCode]);
  const toggleClock=async()=>{
    if(!state||busy)return;
    setBusy(true);setError('');
    try{
      const response=await fetch('/api/v1/staff/time-clock',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{'content-type':'application/json'},
        body:JSON.stringify({
          location:locationCode,
          action:state.status==='clocked_in'?'CLOCK_OUT':'CLOCK_IN',
        }),
      });
      const body=await response.json() as {
        ok:boolean;data?:ClockState;error?:{message?:string}
      };
      if(!response.ok||!body.ok||!body.data)
        throw Error(body.error?.message??'Time clock unavailable.');
      setState(body.data);
    }catch(e){setError(e instanceof Error?e.message:'Time clock unavailable.');}
    finally{setBusy(false);}
  };
  return <div className="ecfs-clock-anchor">
    <button type="button" className="ecfs-clock-trigger"
      aria-label="Clock in or out" aria-expanded={open}
      title={state?.status==='clocked_in'?'Clocked in':'Time clock'}
      onClick={()=>setOpen(v=>!v)}>
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none"
        stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
        strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9"/><path d="M12 6.5V12l3.5 2"/>
      </svg>
      {state?.status==='clocked_in'&&<span className="ecfs-clock-active" aria-hidden="true"/>}
    </button>
    {open&&<div className="ecfs-clock-popover" role="dialog" aria-label="Time clock">
      <strong>Time Clock</strong>
      {loading?<p role="status">Checking clock status…</p>
        :state?<p role="status">
          {state.status==='clocked_in'?'Clocked in':'Not clocked in'}
          {state.status==='clocked_in'&&state.locationCode?' · '+state.locationCode:''}
        </p>:null}
      {state&&<button type="button" disabled={busy}
        onClick={()=>void toggleClock()}>
        {busy?'Updating…':state.status==='clocked_in'?'Clock Out':'Clock In'}
      </button>}
      {error&&<p role="alert">{error}</p>}
    </div>}
  </div>;
}
